// src/components/shared/modals/ConfirmModal.tsx
// Reusable confirmation modal to replace browser confirm() dialogs
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import BaseModal from './BaseModal';
import ModalFooter from './ModalFooter';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'default' | 'danger' | 'warning';
  isLoading?: boolean;
}

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'default',
  isLoading = false
}: ConfirmModalProps) => {
  const isDanger = variant === 'danger';

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={isDanger ? { Component: AlertTriangle, bgColor: 'bg-red-100', color: 'text-red-600' } : null}
      isLoading={isLoading}
    >
      {/* Content */}
      <div className="p-6">
        <p className="text-sm text-gray-600">{message}</p>
      </div>

      {/* Footer */}
      <ModalFooter
        onCancel={onClose}
        onSubmit={handleConfirm}
        cancelText={cancelText}
        submitText={confirmText}
        variant={isDanger ? 'red' : 'blue'}
        isLoading={isLoading}
      />
    </BaseModal>
  );
};

export default ConfirmModal;
